import {Component, Inject, Input} from '@angular/core';
import { Reservation } from '../../api/model/reservation/reservation.model';
import {User} from '../../api/model/user/user.model';
import {IMessage} from "../../api/interfaces/Messages/IMessage";
import {MessagesUtil} from "../../common/messages.util";
import {ReservationErrorMessageKeys} from "../../api/model/errors/reservation-error-message-keys.model";
import {SiteURL, SiteURLUtils} from "../../common/site.url.utils";
import {APP_CONFIG} from "../../api/config/app.config";
import {IAppConfig} from "../../store/interfaces/IAppConfig";

@Component({
  selector: 'reservation-login-required-check',
  templateUrl: './reservation-login-required-check.component.html',
  styleUrls: ['./reservation-login-required-check.component.scss']
})
export class ReservationLoginRequiredCheckComponent {
  private _member: User;
  @Input() messages;
  private _reservation: Reservation;
  message: IMessage;

  constructor(@Inject(APP_CONFIG) protected appConfig: IAppConfig) { }

  get member(): User {
    return this._member;
  }

  @Input() set member(value: User) {
    this._member = value;
    this.initMessage();
  }

  get reservation(): Reservation {
    return this._reservation;
  }

  @Input() set reservation(value: Reservation) {
    this._reservation = value;
    this.initMessage();
  }

  initMessage() {
    this.message = null;
    if (!this._reservation || !this._member) {return}
    const param = SiteURLUtils.getLocalizedSiteUrl(this.appConfig, SiteURL.SIGN_IN);
    if (!this._member.isExplicit() && this.requiresExplicitUser()) {
      this.message = MessagesUtil.toErrorMessage(ReservationErrorMessageKeys.ERROR_AUTHORIZATION, [param], true);
    }
  }

  requiresExplicitUser() {
    return this._reservation.rate.isRewardNight;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/reservation-login-required-check/reservation-login-required-check.component.ts